import { call, put } from 'redux-saga/effects';
import ERRORS from 'constants/errors';
import STEPS from 'constants/steps';
import {
  setError,
  startLoading,
  stopLoading,
  setStep,
  setFirebaseMfaVerificationProps,
  actionFirebaseMfaSuccess
} from 'reduxConfig/auth.creators';
import { NbxCapacitorFirebaseAuth } from '@nbx/capacitor-firebase-auth';

import { createLogger } from 'helpers/logger';
const log = createLogger('[auth-saga] firebaseNativeMfa:');

export function* initFirebaseNativeMfa() {
  try {
    const { verificationId, phoneNumber } = yield call(NbxCapacitorFirebaseAuth.sendFirebaseMfaCode);
    yield put(setFirebaseMfaVerificationProps({ verificationId, phoneNumber }));
    yield put(setStep(STEPS.verifySMSCode));
  } catch (e) {
    log.error('initFirebaseNativeMfa:', e.message);
    yield put(setError(ERRORS.twoFactor));
  } finally {
    yield put(stopLoading());
  }
}

export function* verifyFirebaseNativeMfaCode({ verificationId, verificationCode }) {
  log.info('verifyFirebaseNativeMfaCode', verificationId, verificationCode);
  yield put(setError(null));
  yield put(startLoading());
  try {
    const userCredential = yield call(NbxCapacitorFirebaseAuth.verifyFirebaseMfaCode, {
      verificationId,
      verificationCode
    });
    log.info('verifyFirebaseNativeMfaCode.userCredential', !!userCredential);
    yield put(actionFirebaseMfaSuccess({ userCredential }));
  } catch (e) {
    if (e.code === 'auth-nbx/resolve-mfa-sign-in-error') {
      log.error('verifyFirebaseNativeMfaCode: ', e);
      yield put(setError(ERRORS.twoFactor));
    } else {
      log.error('verifyFirebaseNativeMfaCode: ', e);
      yield put(setError(ERRORS.signup));
    }
  } finally {
    yield put(stopLoading());
  }
}
